<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="card">

            <div class="card-body p-0">

                <div class="row">
                    <div class="col-xl-4 ps-4">
                        <input type="text"
                            class="form-control border-primary outline-dashed py-3 px-3 mt-4 mb-1 text-black w-100"
                            [(ngModel)]="searchForFeatures" (input)="filterFeatures()"
                            placeholder="Search for feature" />
                        <div class="basic-list-group">
                            <ul class="list-group property-height">
                                <li class="list-group-item c-pointer"
                                    *ngFor="let feature of filteredFeaturesList; let i = index"
                                    (click)="selectFeature(i, feature)"
                                    [ngClass]="{'light badge-success float-start' : selectedIndex === i }">
                                    <span class="property-display"> {{feature.action_name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-8 mb-0 pe-4" *ngIf="displayNotificationsList">
                        <label for="exampleFormControlInput1-3"
                            class="alert alert-primary border-primary outline-dashed label-text px-2 mt-4 mb-0 text-black w-100 d-flex align-items-center">
                            {{ selectedFeatureName }}
                        </label>

                        <div class="basic-list-group notifications-list" *ngIf="notifications?.roles">
                            <div class="table-responsive">
                                <form [formGroup]="notificationsForm">
                                    <table class="table mb-0" formArrayName="notifications">
                                        <thead>
                                            <tr>
                                                <th class="w-40">Role</th>
                                                <th>Email</th>
                                                <th>SMS</th>
                                                <th>Whatsapp</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let group of notificationsArray.controls; let i = index" [formGroupName]="i">
                                                <td class="w-40">
                                                    <h6 class="mb-0">{{ group.get('role_name')?.value }}</h6>
                                                </td>
                                                <td>
                                                    <div class="form-check custom-checkbox mb-3 checkbox-warning ms-2">
                                                        <input type="checkbox" formControlName="email" class="form-check-input" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-check custom-checkbox mb-3 checkbox-primary ms-2">
                                                        <input type="checkbox" formControlName="sms" class="form-check-input" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-check custom-checkbox mb-3 checkbox-success me-0 ms-4">
                                                        <input type="checkbox" formControlName="whatsapp" class="form-check-input" />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </form>
                            
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>